import APP_STRINGS from "../languages/EN.json";

//Status codes for api.
export const API_STATUS_CODES = {
  LICENSE_EXPIRED: 402,
};
export const DEFAULT_ERROR_MESSAGE = "Error occurred, please try again!";
//Enumerations
export const ENUMS = {
  COUPON_TYPE: { FLAT: "FLAT", PERCENTAGE: "PERCENTAGE" },
  ALL_DROPDOWN_OPTION: { ID: "ALL", TEXT: "All" },
  DISCOUNT_TYPE: {
    FLAT: "FLAT",
    PERCENTAGE: "PERCENTAGE",
    BUY_X_FOR_Y: "COMBO_TYPE_II",
    BUY_X_GET_Y: "COMBO_TYPE_I",
  },
  COMPANY_TYPE: {
    WITH_FRANCHISE: "WITH_FRANCHISE",
    WITHOUT_FRANCHISE: "WITHOUT_FRANCHISE",
  },
  FRANCHISE_TYPE: {
    DEPENDENT: {
      type: "DEPENDENT",
      title: "Dependent Franchise",
      description: "This franchise won’t have any stores",
    },
    INDEPENDENT: {
      type: "INDEPENDENT",
      title: "Independent Franchise",
      description: "This franchise will have stores",
    },
  },
};

export const disableNumberInputScrollChange = function () {
  //Disables scroll and change number facility in number input.
  document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
      document.activeElement.blur();
    }
  });
};

//Keyboard codes
export const KEY_CODES = {
  SPACE_KEY: "Space",
  DOT_KEY: "Period",
  ENTER_KEY: "Enter",
  NUMPAD_ENTER_KEY: "NumpadEnter",
  NEGATIVE_KEY: "Minus",
};

//Returns object with a component texts to be shown.
export const getComponentTexts = function (location) {
  const splittedLocations = location.split(".");
  let answer = APP_STRINGS[splittedLocations[0]];

  for (let i = 1; i < splittedLocations.length; i++) {
    answer = answer[splittedLocations[i]];
  }

  return answer;
};

export const objectHasKeysCheck = (obj) => {
  return obj && obj.constructor === Object && Object.keys(obj).length > 0;
};

//Submits a form safely when user hits enter
export const safelySubmitFormOnKeyPress = () => {
  document.addEventListener("keypress", (ev) => {
    const { target } = ev;
    //If user hits enter key or numpad key
    if ([KEY_CODES.ENTER_KEY, KEY_CODES.NUMPAD_ENTER_KEY].includes(ev.code)) {
      if (target.type === "search") {
        ev.preventDefault();
      } else {
        let formButton = document.querySelectorAll("form button[type=submit]");
        const lastIndex = formButton.length - 1;
        //check if enter is being hit inside a form and there is a submit button there.
        if (lastIndex >= 0) {
          ev.preventDefault();
          return formButton[lastIndex].click();
        }
      }
    }
  });
};

export const getImageSizeFromBase64 = (base64) => {
  const type = getImageType(base64);
  let stringLength = base64.length - `data:image/${type};base64,`.length;
  let sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  let sizeInMb = sizeInBytes / (1024 * 1024);
  return sizeInMb;
};

export const getImageType = (base64) => {
  const split = base64.split("/");
  const type = split[1].split(";")[0];
  return type;
};

export const webApiCheck = (response) => {
  return (
    response &&
    (response.status === 200 ||
      response.status === 201 ||
      response.status === 204)
  );
};
